<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0px"
      class="demo-ruleForm flex-dir-center"
    >
      <el-form-item style="position:relative" prop="newPassword">
        <el-input show-password v-model="ruleForm.newPassword" placeholder="请输入密码">
          <i slot="prefix" class="el-input__icon el-icon-lock"></i>
        </el-input>
      </el-form-item>
      <el-form-item style="position:relative" prop="conformPassword">
        <el-input show-password v-model="ruleForm.conformPassword" placeholder="请再次输入新密码">
          <i slot="prefix" class="el-input__icon el-icon-lock"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="next-button" :disabled="loading" type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props:{
    verifyId: {
      type: String,
      default: ''
    }
  },
  data() {
    var validNewPass = (rule, value, callback) => {
      let reg = /(?!^(\d+|[A-Z]+|[a-z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,16}$/;
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (!reg.test(value)) {
        callback(
          new Error(
            "密码长度为8-16位;必须包含大写字母、小写字母、数字和特殊字符中的两种或以上"
          )
        );
      } else {
        if (this.ruleForm.confirmPassword !== "") {
          this.$refs.ruleForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
        loading: false,
        ruleForm: {
            newPassword: undefined,
            conformPassword: undefined
        },
        rules: {
            newPassword: [{validator: validNewPass, trigger: "blur"}],
            conformPassword: [{validator: validatePass2, trigger: "blur"}]
        }
    };
  },
  methods: {
    submitForm() {
        this.$refs.ruleForm.validate(async value => {
            if (value) {
                if (this.loading) return
                this.loading = true

                this.$http.post(this.$api.register.retrievePassword, {
                    password: this.ruleForm.newPassword,
                    verifyId: this.verifyId
                }, {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$emit("changeActive", 3);
                    } else {
                        this.$message.error(res.data.msg);
                    }

                    this.loading = false
                }).catch(() => {
                    this.loading = false
                    this.$message.error('出错了，请稍后重试');
                });
            }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.captcha-item {
  position: relative;
}
.get-cap {
  position: absolute;
  right: 20px;
  top: 0;
  color: #407fff;
  cursor: pointer;
}
.next-button {
  width: 370px;
  height: 42px;
  margin-top: 20px;
  font-size: 16px;
  box-shadow: 0 2px 4px 0 rgba(64, 129, 255, .4)
}
.icon-eye {
  position: absolute;
  top: 10px;
  right: 15px;
  width: 18px;
  height: 18px;
}
::v-deep .el-form-item {
  margin-bottom: 28px !important;
}
::v-deep .el-form-item__error {
  text-align: left !important;
}
::v-deep .el-input .el-input__inner {
  width: 370px;
}
</style>
